import React, { ReactNode, useEffect, useState } from "react";
import useCurrentUser from "../../hooks/useCurrentUser";
import { ETaskStatus, ITask } from "../../data_models/task";
import { FilledButton } from "../common/Button";
import useRouting from "../../hooks/useRouting";
import { TaskEnumTextMapper } from "../../data_models/enumToTextMapper";
import { TiArrowForwardOutline } from "react-icons/ti";
import IconButton from "../common/IconButton";
import { TaskStatusBatch } from "../common/StatusBatch";
import useMyTasks from "../../hooks/useMyTasks";
import useTasks from "../../hooks/useTasks";
import { dateToShortReadable } from "../../utils/dateUtils";


interface FreelancerTasksTableProps {
    header: string;
    tasks: ITask[];
}

const FreelancerTasksTable: React.FC<FreelancerTasksTableProps> = ({ header, tasks }) => {

    const { tasksAsFreelancerInProgress } = useMyTasks();

    const { goToJobs, goToProjectDetails } = useRouting();

    return (
        <div className="">
            <p className="body1 font-bold">{header}</p>
            {/* No data available  */}
            {tasks.length === 0 && <div className="mt-4 flex flex-col items-center space-y-4">
                <img
                    src="https://storage.googleapis.com/public-platform-assets/images/no_data.svg"
                    alt="No Data"
                    className="w-2/3"
                />
                <p className="body1">You do not have any active tasks</p>
                <FilledButton onClick={goToJobs}>
                    Find Tasks
                </FilledButton>
            </div>}

            {/* Task Table */}
            {tasks.length > 0 && <div className="flex flex-col border border-neutral rounded-md min-w-fit">
                {/* Header */}
                <div className="grid grid-cols-6 gap-2 p-2 bg-secondary-100">
                    <p className="body3 font-bold">Due</p>
                    <p className="body3 font-bold col-span-3">Task</p> {/* This cell spans two columns */}
                    <p className="body3 font-bold col-span-2">Status</p>
                </div>

                {tasks.map((task, index) => (<div key={task._id || index} className="grid grid-cols-6 p-2 border-t border-neutral">
                    <div className="caption2 flex items-center">{task.dueDate ? dateToShortReadable(task.dueDate) : '-'}</div>
                    <div className="caption2 col-span-3 flex items-center">{task.title || '-'}</div> {/* This cell spans two columns */}
                    <div className="caption2 col-span-2 flex flex-row justify-between items-center">
                        <TaskStatusBatch status={task.currentStatus} variant="flat" />
                        <IconButton
                            onClick={() => goToProjectDetails(task.projectId!)}
                            icon={<TiArrowForwardOutline />}
                            size="s"
                        />

                    </div>
                </div>))}
            </div>}
        </div >
    );
};




export default FreelancerTasksTable;